import React, { useState, useEffect, Component } from "react";
import {Link,useHistory} from 'react-router-dom'
// import {getIdFromPath, getDoc, getDocById, updateDocById, noImage, uploadImage,uploadImageDynamic, dateFormat} from '../config/projectConfig';
import {JsonPretty, ElmentShow, FacebookMessageUs, ContactIcon,ContactIconBar,ContactIconSector} from '../config/projectConfig';
import { Nav, Navbar, NavDropdown, Form, FormControl, Button, ButtonGroup, InputGroup, Modal, Row, Col, Container } from 'react-bootstrap';

import { withFirebase } from '../components/Firebase'
import { LabelTextInput, LabelImageInput, TextInput, ImageInput } from '../config/formUtils'
import { loadMaster, dateFormat, uploadImage, getDoc, getDocById, getCol, getColById, updateDocById, uploadImageDynamic, getIdFromPath } from '../config/dbUtils'

const Page = (props) => {
  const firebase = props.firebase;
  const firestore = props.firebase.firestore;
  const db = props.firebase.firestore;
  // const collection = db.collection("company");

    const [hideControl, setHideControl] = useState(false);
    const [helmet, setHelmet] = useState({}); 
    const [docId,setDocId] = useState(0);
    const [doc, setDoc] = useState({}); 
    useEffect(() => {
      var idFromPath = getIdFromPath(4);
      // console.log("id ------- ", props.localtion)
      getDocById(firebase, setDoc, setDocId, "company", idFromPath);
      // if(null) useHistory().push('/website')
    },[]);
    const clearDoc = (e) => { setDoc({})}
    const onSubmitUpdate = (e) => {
      updateDocById(firebase, "company", (e)=>{} , doc, docId);
    }
    const docChange = (key,value,index) => { console.log("docChange("+key+","+index+","+value+")"); setDoc({ ...doc, [key]: value }); }
    const imgChange = (key,value,index,path) => { console.log("imgChange("+key+","+value+","+index+","+path+")"); uploadImageDynamic(firebase,doc, setDoc, key, value, path); };
      return (
        <div className="App" >   
            <h1>Company</h1>
            <Container>
              <Form>
                <LabelImageInput as={Row} label="Company Logo" name="companyLogo" path="images" value={doc} event={imgChange} />
                <LabelImageInput as={Row} label="Company Icon" name="companyIcon" path="images" value={doc} event={imgChange} />
                <LabelTextInput as={Row} label="Company Name" placeholder="example : upbrand co.,ltd." name="companyName" value={doc} event={docChange} />
                <LabelTextInput as={Row} label="Short Name" placeholder="example : upbrand" name="companyShortName" value={doc} event={docChange} />
                <br/><h1>Contact</h1><br/>
                <LabelTextInput as={Row} label="Email"placeholder="example : contact@upbrand.asia" name="email" value={doc} event={docChange} />

                <LabelTextInput as={Row} label="Phone"placeholder="example : 081 123 4567" name="phone" value={doc} event={docChange} />
                <LabelTextInput as={Row} label="Facebook Id"placeholder="example : upbrand.asia" name="facebook" value={doc} event={docChange} />
                <LabelTextInput as={Row} label="Line Id"placeholder="example : @upbrand.asia" name="line" value={doc} event={docChange} />
                <LabelTextInput as={Row} label="Instagram Id"placeholder="example : upbrand.asia" name="instagram" value={doc} event={docChange} />
                <LabelTextInput as={Row} label="Twitter Id"placeholder="example : upbrand.asia" name="twitter" value={doc} event={docChange} />
                <LabelTextInput as={Row} label="Youtube"placeholder="example : UCl7HAjgFN3HUZe3KaQmJDSQ" name="youtube" value={doc} event={docChange} />

                <LabelTextInput as={Row} label="Address"placeholder="example : เลขที่ 123 แขวงบางรัก เขตบางรัก กทม 10600" name="address" value={doc} event={docChange} />
                อัพเดทล่าสุดเมื่อ {dateFormat(doc.updateDate)}
              </Form>
            </Container>
            <div hidden={hideControl}>
                <br/>
                <ButtonGroup className="">
                    <Link to="../website"> <Button variant="secondary" hidden={hideControl}> Back</Button> </Link>
                    <Button variant="primary" hidden={hideControl} onClick={() => onSubmitUpdate()}> Save Update </Button>
                    <Button variant="danger" hidden={hideControl} onClick={() => setDoc({})}> Clear </Button>
                </ButtonGroup>
            </div>

            <Form.Check type="checkbox" name="hideBtn" label="Hide Control" style={{textAlign:"left",marginLeft:"15px"}} onChange={e => setHideControl(e.target.checked ? true : false)} />
            <div hidden={hideControl}> <JsonPretty style={{textAlign:"left"}} data={doc}></JsonPretty> </div>
        </div>
    );
}
  
class ExportPage extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
        <Page firebase={this.props.firebase} />
    );
  }
}

export default withFirebase(ExportPage);